/** @internal */
export function getModelPercentFactory() {

    return ["$filter", ($filter) => {

        return {


            require: "ngModel",

            link: (scope, elements, attrs, ctrl: ng.INgModelController) => {

                var decimals = parseInt(attrs["omniaModelPercent"]) || 0;

                ctrl.$parsers.unshift(
                    function(viewValue) {
                        return $filter('number')(parseFloat(viewValue) / 100, decimals + 2);
                    }
                );
                ctrl.$formatters.unshift(
                    function(modelValue) {
                        return $filter('number')(parseFloat(modelValue) * 100, decimals);
                    }
                );
            }

        };

    }];

};
